module.exports = __webpack_public_path__ + "img/background-changer-after.7f0054e5.jpg";